import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { Popover, Heading, FieldSet, FormHelp, Flex, LabeledControl, Label, Checkbox, Popper } from '@zillow/constellation';
import { useFormContext, useFormState } from 'react-hook-form';

/**
 *
 */
function CheckboxField(_ref) {
  var _proxyFormState$error;
  var config = _ref.config,
    description = _ref.description,
    disabled = _ref.disabled,
    label = _ref.label,
    name = _ref.name,
    _onChange = _ref.onChange,
    popover = _ref.popover;
  var form = useFormContext();
  var trigger = popover ? /*#__PURE__*/React.createElement(Popover, {
    header: /*#__PURE__*/React.createElement(Heading, {
      level: 6
    }, popover === null || popover === void 0 ? void 0 : popover.title),
    body: popover === null || popover === void 0 ? void 0 : popover.body
  }) : false;
  var proxyFormState = useFormState();
  var error = proxyFormState === null || proxyFormState === void 0 || (_proxyFormState$error = proxyFormState.errors[name]) === null || _proxyFormState$error === void 0 ? void 0 : _proxyFormState$error.message;
  var field = form.register(name, config);
  return /*#__PURE__*/React.createElement(FieldSet, {
    description: /*#__PURE__*/React.createElement(FormHelp, {
      error: Boolean(error)
    }, error || description)
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(LabeledControl, {
    label: /*#__PURE__*/React.createElement(Label, null, label),
    control: /*#__PURE__*/React.createElement(Checkbox, _extends({}, field, {
      disabled: disabled,
      onChange: function onChange(e) {
        field.onChange(e);
        _onChange === null || _onChange === void 0 || _onChange(e);
      }
    }))
  }), trigger && /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0", /*#__PURE__*/React.createElement(Popper, {
    triggered: trigger
  }))));
}
CheckboxField.propTypes = process.env.NODE_ENV !== "production" ? {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  config: PropTypes.shape({
    required: PropTypes.string,
    validate: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func])
  }),
  popover: PropTypes.shape({
    title: PropTypes.string,
    body: PropTypes.element
  }),
  onChange: PropTypes.func
} : {};
CheckboxField.defaultProps = {
  config: undefined,
  description: undefined
};

export { CheckboxField as default };
